// Generated by CoffeeScript 1.12.6
var _, opsProductTraits;

_ = require('lodash');

opsProductTraits = require('ge-ops-product-traits');

module.exports = {
  status: ['active', 'discontinued'],
  storageTypes: _.reject(opsProductTraits.storageTypes, function(storageType) {
    return storageType === 'virtual';
  }),
  orderingUnits: opsProductTraits.orderingUnits,
  comparisonUnits: opsProductTraits.comparisonUnits,
  packagingFormats: opsProductTraits.packagingFormats,
  catalogProductSupplierSlugsNotToMigrate: ['capacities', 'dinnerkitcapacities', 'dinnerkitcapacities10pmsaturdaycutoff'],
  catalogProductStructuresToMigrate: ['non-differentiating', 'auto-differentiating', 'auto-differentiating yield not 1', 'needs prep', 'non-fungible']
};
